import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import genericSupplierClient from 'Services/Apis/Spot/genericSupplierClient';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';

const initialState = {
  loadingSubsegmento: false,
  loadingIsManager: false,
  loadingParticipantGroups: false,
  dataSubSegmento: {
    participantSubsegment: '',
    isFocalizationAnalyst: false,
    participantTest: {},
  },
  hasSyngentaHierarchy: false,
  participantsGroups: [],
  countTry: 0,
  loadingDataTracking: false,
  spotDataTracking: null,
  errorSpotDataTracking: false,
};

export const loadSpotTracking = createAsyncThunk(
  'spotGroupsSlice/loadSpotTracking',
  async ({ redemptionId }, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.get(
      `/Tracking/${redemptionId}`,
      {
        headers,
      }
    );

    return data;
  }
);

export const loadUserGroupsParticipant = createAsyncThunk(
  'spotGroupsSlice/loadUserGroupsParticipant',
  async (arg, { dispatch, getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await genericSupplierClient.get(`/api/ParticipantGroup`, {
      headers,
    });

    if (data.length === 0) {
      dispatch(incrementCountTry());
    } else {
      return data;
    }
  }
);

export const loadSubsegmentGroups = createAsyncThunk(
  'spotGroupsSlice/loadSubsegmentGroups',
  async (arg, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.get(
      `/Syngenta/Participant?username=${headers.username}`,
      {
        headers,
      }
    );

    return data;
  }
);

export const loadWalletIsManager = createAsyncThunk(
  'spotGroupsSlice/loadWalletIsManager',
  async (arg, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.get(
      `/Syngenta/Wallet?username=${headers.username}`,
      {
        headers,
      }
    );

    return data;
  }
);

const spotGroupsSlice = createSlice({
  name: 'spotGroupsSlice',
  initialState,
  reducers: {
    resetSpotTracking(state) {
      state.spotDataTracking = null;
      state.errorSpotDataTracking = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadSubsegmentGroups.pending, (state) => {
        state.loadingSubsegmento = true;
      })
      .addCase(loadSubsegmentGroups.fulfilled, (state, action) => {
        state.loadingSubsegmento = false;
        state.dataSubSegmento = {
          participantSubsegment: action.payload.subSegmentoCrop,
          isFocalizationAnalyst: action.payload.isFocusAnalyst,
          participantTest: {
            ...action.payload,
          },
        };
      })
      .addCase(loadSubsegmentGroups.rejected, (state) => {
        state.loadingSubsegmento = false;
      })
      .addCase(loadWalletIsManager.pending, (state) => {
        state.loadingIsManager = true;
      })
      .addCase(loadWalletIsManager.fulfilled, (state, action) => {
        state.loadingIsManager = false;
        if (action.payload.length > 0) {
          state.hasSyngentaHierarchy = true;
        } else {
          state.hasSyngentaHierarchy = false;
        }
      })
      .addCase(loadWalletIsManager.rejected, (state) => {
        state.loadingIsManager = false;
        state.hasSyngentaHierarchy = false;
      })
      .addCase(loadUserGroupsParticipant.pending, (state) => {
        state.loadingParticipantGroups = true;
      })
      .addCase(loadUserGroupsParticipant.fulfilled, (state, action) => {
        state.loadingParticipantGroups = false;
        state.participantsGroups = action.payload;
      })
      .addCase(loadUserGroupsParticipant.rejected, (state) => {
        state.loadingParticipantGroups = false;
        state.participantsGroups = [];
      });

    builder
      .addCase(loadSpotTracking.pending, (state) => {
        state.loadingDataTracking = true;
      })
      .addCase(loadSpotTracking.fulfilled, (state, action) => {
        state.loadingDataTracking = false;
        state.spotDataTracking = action.payload;
      })
      .addCase(loadSpotTracking.rejected, (state) => {
        state.loadingDataTracking = false;
        state.spotDataTracking = null;
        state.errorSpotDataTracking = true;
      });
  },
});
export const { resetSpotTracking } = spotGroupsSlice.actions;
export default spotGroupsSlice.reducer;
